import React from 'react';
import type { ScenarioNode } from 'shared';

interface StepTimelineProps {
  node: ScenarioNode | null;
  currentIndex: number;
}

export const StepTimeline: React.FC<StepTimelineProps> = ({ node, currentIndex }) => {
  if (!node) {
    return null;
  }

  return (
    <div className="timeline">
      <p className="eyebrow">Node Timeline</p>
      <ul>
        {node.steps.map((step, index) => (
          <li key={step.id} className={index === currentIndex ? 'active' : ''}>
            <span className="timeline__type">{step.type}</span>
            <span className="timeline__title">{step.title || step.id}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};



